import type { AnswerType } from '@webapp/common/resources/survey';

export interface QuestionCol {
    id: number;
    name: string;
    type?: AnswerType;
    exception?: boolean | null;
    pinned?: boolean | null;
    answers?: Array<string>;
    order?: number;
    numeric_value?: number;
    questionId?: number;
    isNew?: boolean;
}

export const initialCol: Readonly<QuestionCol> = {
    id: 0,
    name: '',
    type: null,
    exception: null,
    pinned: null,
    answers: [],
};
